<script setup>
import { computed, reactive } from "vue";
import { daysM, months, firstDay } from "db";
import { getUnixTime } from "date-fns";

const props = defineProps({
	activeDates: {
		type: Object,
		default() {
			return null;
		}
	},
	modelValue: Number
});
defineEmits(["update:modelValue"]);

const today = toDateNum(new Date());

let d;

if (Number.isFinite(props.modelValue))
	d = new Date(props.modelValue * 1000);
else
	d = new Date();

const m = reactive({
	year: d.getFullYear(),
	month: d.getMonth() + 1,
	offset: 0,
	days: 30
});

const ym = computed(() => m.year * 10000 + m.month * 100);

const selected = computed(() => {
	if (!Number.isFinite(props.modelValue))
		return null;

	return toDateNum(new Date(props.modelValue * 1000));
});

function toDateNum(date) {
	return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
}

function update()
{
	const date = new Date(m.year, m.month - 1);
	const day = date.getDay();

	m.offset = (day + 7 - firstDay) % 7;

	date.setMonth(m.month);
	date.setDate(date.getDate() - 1);

	m.days = date.getDate();
}

function prev()
{
	m.month--;

	if (m.month < 1) {
		m.month = 12;
		m.year--;
	}

	update();
}

function next()
{
	m.month++;

	if (m.month > 12) {
		m.month = 1;
		m.year++;
	}

	update();
}

update();
</script>

<template>
	<div class="vui-date-picker">
		<div class="head grid align-items-center">
			<button type="button" class="vui-btn text" @click="prev()"><i class="fa-solid fa-chevron-left"></i></button>
			<div class="title"><span class="month">{{ months[m.month - 1] }}</span><span>{{ m.year }}</span></div>
			<button type="button" class="vui-btn text" @click="next()"><i class="fa-solid fa-chevron-right"></i></button>
		</div>
		<div class="body">
			<span v-for="dow in 7" class="dow">{{ daysM[(dow - 1 + firstDay) % 7] }}</span>
			<span v-if="m.offset > 0" :style="{ gridColumn: 'span ' + m.offset }"></span>
			<button
				v-for="day in m.days"
				type="button"
				class="vui-btn text day"
				:class="{
					selected: selected === ym + day,
					today: today === ym + day
				}"
				:disabled="activeDates !== null && !(ym + day in activeDates)"
				@click="$emit('update:modelValue', getUnixTime(new Date(m.year, m.month - 1, day)))"
			>
				{{ day }}
			</button>
		</div>
	</div>
</template>
